
import { Cell, CellGroup, ImagePreview } from 'vant'
import { errorModal } from '../../../assets/js/xjcommon';

export default {
  name: 'home',
  components: {
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [ImagePreview.name]: ImagePreview
  },
  data () {
    return {
      // 公众号
      nowImei: $cookies.get('imei'),
      cameraType: this.$store.state.devCameraList.length > 0 ? this.$store.state.devCameraList[0].name : '暂无摄像头',
      cameraTypeValue: this.$store.state.devCameraList.length > 0 ? this.$store.state.devCameraList[0].value : 0,
      // 下拉选择
      showActionSheetCamera: false,
      cameraTypeList: this.$store.state.devCameraList,
      // cameraTypeList: [
      //   { name: '前置摄像头', value: 1 },
      //   { name: '后置摄像头', value: 2 },
      //   { name: '前+后摄像头', value: 3 }
      // ],
      // 照片地址
      imgArray: [],
      isangle: window.orientation == 90 || window.orientation == -90,
    }
  },
  methods: {
    // 选择摄像头
    selectCameraFn () {
      this.showActionSheetCamera = true;
    },
    onSelectCameraFn (item) {
      this.cameraType = item.name;
      this.cameraTypeValue = item.value;
      this.showActionSheetCamera = false;
    },
    // 拍照请求
    takePictureFn () {
      if (this.cameraType === '暂无摄像头') {
        this.$dialog({
          message: '暂无摄像头'
        });
        return
      }
      this.imgArray = [];
      this.$toast.loading({
        mask: true,
        duration: 0,
        message: '正在获取...'
      });
      let _this = this;
      this.$axios.post('/v3/u/action/realTimePhoto', { camera: this.cameraTypeValue }, { timeout: this.$store.state.timeoutLongTime })
        .then((response)=>{
          // console.log(response);
          this.$toast.clear();
          if (response.data.ret === 0) {
            // 需要对文件地址解码
            let imgData = response.data.data|| [];
            this.imgArray = imgData.map(item=>{
              return {
              ...item,
              typeName: item.camera === 1 ? '前置摄像头照片' : item.camera === 2 ? '后置摄像头照片' : '全景摄像头照片',
            }});

          } else {
            this.$dialog({
              message: response.data.msg ? response.data.msg + '（' + response.data.ret + '）' : '拍照失败（' + response.data.ret + '）'
            })
          }
        })
        .catch((error)=>{
          this.$toast.clear();
          errorModal(error, 121);
        })
    },
    // 预览照片
    previewImageFn (imgIndex) {
      let imgData = this.imgArray;
      let imgArray = [];
      for (let i = 0; i < imgData.length; i++) {
        imgArray.push(imgData[i].url);
      }
      // ImagePreview(imgArray);
      ImagePreview({
        images: imgArray,
        startPosition: imgIndex
      });
    },
    change3DImg(item,id='demoImage'){
      setTimeout(()=>{
        this.player = new EapilRender(document.getElementById(id),{
            DataType: EapilRender.DATATYPE.IMG,
            SourceUrl:item.url,
            Template: localStorage.getItem('cameraTemplate')
          });
      },180)
    },
    change3DVideo(item,id='d3Video'){
      setTimeout(()=>{
        this.player = new EapilRender(document.getElementById(id), {
          poster: item.thumb,
          DataType: EapilRender.DATATYPE.MP4,
          RoateXY: { "xValue": 0, "yValue": 0 },
          SourceUrl: item.url,
          Template: localStorage.getItem('cameraTemplate'),
        });
      },180)
    },
    fullScreenHandle(item,type){
      window.scroll(0,0);
      document.body.style.overflow = 'hidden'
      this.isshow = true;
      this.d3Type = item.mtype;
      this.d3item = item;
      this[type](item,'demoVideo')
    },
    closeHandle(){
        document.body.style.overflow = 'auto'
        this.cleanCache()
        this.isshow = false;
        this.key = Math.random();
    },
    cleanCache(){
      try {
        this.player.destroy()
      } catch (error) {
        document.getElementById('demoVideo').innerHTML = ''
      }
    },
    // 跳转到查询页面
    queryPictureFn () {
      this.$router.push('/queryMedia?type=1')
    },
    // 切换设备
    toChangeDevPageFn () {
      this.$router.push('/changeDev')
    }
  },
  actionHandle(){
    this.isangle = screen.orientation.angle === 90;
  },
  created () {
    // localStorage 删除本地存储(用户的查询条件)
    localStorage.removeItem('xjWxQueryMediaStartTime');
    localStorage.removeItem('xjWxQueryMediaEndTime');
    localStorage.removeItem('xjWxQueryMediaCamera');
    localStorage.removeItem('xjWxQueryMediaPictureType');
    window.addEventListener("orientationchange",this.actionHandle,false);
  },

  destroyed () {
    window.removeEventListener('orientationchange',this.actionHandle);
    this.$toast.clear();
  }
}
